module.exports = __webpack_public_path__ + "media/images/manager-icon-09e8c058c27ed76918fd0e7f61150e32.png";